<nav
  [animate.enter]="'slide-in-left'"
  aria-label="Navigation"
  class="main-menu h-screen p-5">
  <div
    [style.width.px]="width()"
    class="menu-shell flex h-full flex-col overflow-hidden rounded-2xl border border-white/15 bg-primary-500 shadow-md shadow-slate-900/30">

    <!-- Logo -->
    <div
      [class.justify-center]="!isExpanded()"
      [class.px-0]="!isExpanded()"
      class="flex h-16 shrink-0 items-center gap-3 border-b border-white/10 px-5">
      <img [height]="22" [width]="22" alt="RAMASOFT" ngSrc="images/Icon-RAMASOFT-blanc.png" priority>
      @if (isExpanded()) {
        <img [height]="20" [width]="150" alt="RAMASOFT" ngSrc="images/RAMASOFT-blanc.png" priority>
      }
    </div>

    <!-- Navigation items -->
    <ul class="m-0 flex flex-1 list-none flex-col gap-1 overflow-y-auto overflow-x-hidden p-3">
      @for (item of visibleItems(); track item.routerLink) {
        <li>
          <a
            [attr.data-testid]="'nav-' + item.routerLink.replace('/', '')"
            [class.is-active]="isActive(item)"
            [class.justify-center]="!isExpanded()"
            [pTooltip]="isExpanded() ? '' : (item.label | translate)"
            [routerLink]="item.routerLink"
            class="main-menu-link relative flex h-11 items-center overflow-hidden rounded-xl px-3"
            pRipple
            tooltipPosition="right">
            <elcia-icon [iconSize]="'xl'" [iconType]="item.icon"/>
            @if (isExpanded()) {
              <span class="ml-3 whitespace-nowrap text-base font-medium">{{ item.label | translate }}</span>
            }
          </a>
        </li>
      }
    </ul>

    <!-- Collapse toggle -->
    <div class="shrink-0 border-t border-white/10 p-3">
      <button
        (click)="toggleSize()"
        [attr.aria-label]="(isExpanded() ? 'app.menu-collapse' : 'app.menu-expand') | translate"
        [class.justify-center]="!isExpanded()"
        class="main-menu-toggle flex h-10 w-full cursor-pointer items-center rounded-xl px-3"
        type="button">
        <elcia-icon [iconSize]="'lg'" [iconType]="isExpanded() ? 'chevron-left' : 'chevron-right'"/>
        @if (isExpanded()) {
          <span class="ml-3 text-sm font-medium">{{ 'app.menu-collapse' | translate }}</span>
        }
      </button>
    </div>
  </div>
</nav>
